'use strict';

const isSmallView = () => {
    const mobileMaxWidth = 767;
    const vpWidth = $(window).width();

    return vpWidth <= mobileMaxWidth;
};

module.exports = isSmallView;
